/*jslint node: true, browser: true*/
"use strict";

var dateFormatter = require("pli/util/date").formatDate;
var ko = require("pli/knockout");
var pliObservable = require("pli/forms-knockoutcontrols");

var viewModelInit = require("./viewModelInitExtensions");

require("../ko-expandtext");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Comment class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// Define CommentViewModel
function CommentViewModel(factories) {
    if (window.console && window.console.group) { window.console.log("CommentViewModel.ctor", factories); }

    // serializable properties
    this.guid = ko.observable(null);
    this.id = ko.observable(null);
    this.message = ko.observable(null);

    // extra properties
    this.extras = function CommentExtras() { return; };
    this.extras.createdDate = ko.observable(null);
    this.extras.createdByName = ko.observable(null);
    this.extras.updatedDate = ko.observable(null);
    this.extras.updatedByName = ko.observable(null);

    this.extras.editMode = ko.observable(false);
    this.extras.editMessage = ko.observable(null);
    this.extras.editedBy = ko.computed(CommentViewModel.prototype.editBySummary, this);
}


//-------------------------------------------
CommentViewModel.prototype.loadViewModel = function commentsLoaded(record) {
    if (window.console && window.console.group) { window.console.log("CommentViewModel.loadViewModel", record); }

    if (!record) { record = {}; }

    this.guid(record.guid || null);
    this.id(record.id || null);
    this.message(record.message || null);

    this.extras.createdDate(record.createdDate || null);
    this.extras.createdByName(record.createdByName || null);
    this.extras.updatedDate(record.updatedDate || null);
    this.extras.updatedByName(record.updatedByName || null);

    this.extras.editMessage(record.message || null);
};


//-------------------------------------------
CommentViewModel.prototype.convertToLocalDateTimeString = function convertLocalDateTime(dateString) {
    if (dateString) {
        // Given an UTC datetime string, Date constructor will automatically convert it to the local date time
        var localDate = new Date(dateString);

        return dateFormatter(localDate, "MMM-dd-yyyy @ HH:mm");
    }
};


//-------------------------------------------
CommentViewModel.prototype.editBySummary = function editBySummary() {
    if (this.extras.updatedByName() && this.extras.updatedDate()) {
        return " | Edited by " + this.extras.updatedByName() + " " + this.convertToLocalDateTimeString(this.extras.updatedDate());
    }

    return null;
};


//-------------------------------------------
// Revert the editMessage back to the original message since user cancelled edit
CommentViewModel.prototype.cancel = function cancelEdit() {
    this.extras.editMessage(this.message());
    this.extras.editMode(false);
};


//-------------------------------------------
// Update message to the editMessage and update updated info
CommentViewModel.prototype.update = function updateEdit() {
    this.message(this.extras.editMessage());

    this.extras.editMode(false);
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = viewModelInit.standardFactoryCreatorFor(
    CommentViewModel,
    "comments"
);



//////////////////
// WEBPACK FOOTER
// ./app/document/commentViewModel.js
// module id = 546
// module chunks = 49